<template>
    <div class="Show">
        <van-nav-bar title="订单支付"
            left-text=""
            left-arrow
            @click-left="$router.back(-1)"
        />
        <div class="cmain pend_main">
            <van-cell-group class="detailmain paymentmain">
                <van-cell class="payorder">
                    <span slot="title">订单号</span>
                    <span class="orderid">{{orderDetail.id}}</span>
                </van-cell>
                <van-cell class="small time">
                    <span slot="title">下单时间</span>
                    <span>{{orderDetail.creationTime}}</span>
                </van-cell>
                <div class="products">
                    <dl v-for="item in orderDetail.items">
                        <dt>{{item.commodityName}}</dt>
                        <dd>x{{item.quantity}}</dd>
                        <div class="clearb"></div>
                    </dl>
                </div>
                <!--<van-cell class="small">
                    <span slot="title">订单金额</span>
                    <span class="money">{{ getPriceType(orderDetail.priceType).symbol }}{{orderDetail.paymentAmount}} {{ getPriceType(orderDetail.priceType).unit }}</span>
                </van-cell>-->
                <van-cell class="small">
                    <span slot="title">订单总金额</span>
                    <span class="">{{ getPriceType(orderDetail.priceType).symbol }}{{orderDetail.totalAmount}} {{ getPriceType(orderDetail.priceType).unit }}</span>
                </van-cell>
                <van-cell class="small">
                    <span slot="title">商品金额</span>
                    <span class="">{{ getPriceType(orderDetail.priceType).symbol }}{{orderDetail.productsAmount}} {{ getPriceType(orderDetail.priceType).unit }}</span>
                </van-cell>
                <van-cell class="small" v-if="orderDetail.freight">
                    <span slot="title">快递运费</span>
                    <span class="">{{ getPriceType(orderDetail.priceType).symbol }}{{orderDetail.freight}} {{ getPriceType(orderDetail.priceType).unit }}</span>
                </van-cell>
                <van-cell class="small" v-if="orderDetail.needTakePhoto">
                    <span slot="title">标记拍照服务费</span>
                    <span class="">{{ getPriceType(orderDetail.priceType).symbol }}{{orderDetail.takePhotoAmount}} {{ getPriceType(orderDetail.priceType).unit }}</span>
                </van-cell>
                <van-cell class="small" v-if="orderDetail.serviceAmount && orderDetail.payStatus === 2">
                    <span slot="title">手续费</span>
                    <span class="">{{ getPriceType(orderDetail.priceType).symbol }}{{orderDetail.serviceAmount}} {{ getPriceType(orderDetail.priceType).unit }}</span>
                </van-cell>
                <van-cell class="small" v-if="orderDetail.cashAmount">
                    <span slot="title">余额抵扣</span>
                    <span class="">-{{ getPriceType(orderDetail.priceType).symbol }}{{orderDetail.cashAmount}} {{ getPriceType(orderDetail.priceType).unit }}</span>
                </van-cell>
                <van-cell class="small" v-if="orderDetail.couponAmount">
                    <span slot="title">优惠卷抵扣</span>
                    <span class="">-{{ getPriceType(orderDetail.priceType).symbol }}{{orderDetail.couponAmount}} {{ getPriceType(orderDetail.priceType).unit }}</span>
                </van-cell>
                <van-cell class="small">
                    <span slot="title">应付金额</span>
                    <span class="money">{{ getPriceType(orderDetail.priceType).symbol }}{{orderDetail.paymentAmount}} {{ getPriceType(orderDetail.priceType).unit }}</span>
                </van-cell>
            </van-cell-group>
            <van-radio-group v-model="radio">
                <van-cell-group class="paygroup">
                    <van-cell clickable @click="radio = '1'" v-if="!browser.alipay"><!-- v-if="browser.wechat"-->
                        <template slot="title">
                            <img src="@/assets/frontend/images/icon_wx@2x.png" alt=""/>
                            <span>微信支付 <template v-if="!orderDetail.priceType">(手续费{{amountRate}}%)</template></span>
                        </template>
                        <van-radio name="1" checked-color="#07c160" />
                    </van-cell>
                    <van-cell clickable @click="radio = '2'" v-if="!browser.wechat"><!-- v-if="browser.alipay || browser.other"-->
                        <template slot="title">
                            <img src="@/assets/frontend/images/icon_ZFB@2x.png" alt=""/>
                            <span>支付宝支付 <template v-if="!orderDetail.priceType">(手续费{{amountRate}}%)</template></span>
                        </template>
                        <van-radio name="2" checked-color="#07c160" />
                    </van-cell>
                    <van-cell clickable @click="radio = '3'" v-if="!orderDetail.priceType">
                        <template slot="title">
                            <img src="@/assets/frontend/images/icon_yh@2x.png" alt=""/>
                            <span>银行卡转账 (澳洲银行转账)</span>
                        </template>
                        <van-radio name="3" checked-color="#07c160" />
                    </van-cell>
                </van-cell-group>
            </van-radio-group>
            <div style="height: 115px;"></div>
            <van-submit-bar
                label="待支付："
                button-text="确认支付"
                :currency="getPriceType(orderDetail.priceType).symbol"
                @submit="onSubmitPay"
            >
                <!--:price="orderDetail.paymentAmount * 100"-->
                <div class="order_result"><span class="amount">待付：{{ getPriceType(orderDetail.priceType).symbol }}{{parseFloat(orderDetail.paymentAmount)}}{{ getPriceType(orderDetail.priceType).unit }}</span><br /><span class="rmb" v-if="!orderDetail.priceType">(人民币约：{{paymentAmountRMB}}元)</span></div>
            </van-submit-bar>

            <van-popup class="paybankpopup" v-model="isShowCode" position="bottom">
                <van-nav-bar :title="radio == '1' ? '微信支付' : radio == '2' ? '支付宝支付' : ''"
                    left-text=""
                    left-arrow
                    @click-left="isShowCode = false"
                />
                <van-cell-group class="detailmain">
                    <van-cell class="paybank">
                        <template slot="title">
                            <span>订单金额:</span>
                            <span class="fwb">{{ getPriceType(orderDetail.priceType).symbol }}{{orderDetail.paymentAmount}} {{ getPriceType(orderDetail.priceType).unit }}</span>
                        </template>
                    </van-cell>
                    <van-cell class="paybank" v-if="!orderDetail.priceType">
                        <template slot="title">
                            <span>手续费:</span>
                            <span class="fwb">{{ getPriceType(orderDetail.priceType).symbol }}{{serviceAmount}} {{ getPriceType(orderDetail.priceType).unit }}</span>
                        </template>
                    </van-cell>
                    <van-cell class="paybank">
                        <template slot="title">
                            <span>支付总额:</span>
                            <span class="fwb">{{ getPriceType(orderDetail.priceType).symbol }}{{totalAmounts}} {{ getPriceType(orderDetail.priceType).unit }}</span>
                        </template>
                    </van-cell>
                    <van-cell class="paybank">
                        <template slot="title">
                            <span>订单号:</span>
                            <span class="fwb">{{orderDetail.id}}</span>
                        </template>
                    </van-cell>
                    <van-cell>
                        <qriously :value="wxQRCode" v-if="radio == '1'" :size="200" style="width: 200px; heigth: 200px; display: block; margin: 0 auto;"></qriously>
                        <qriously :value="alipayQRCode" v-if="radio == '2'" :size="200" style="width: 200px; heigth: 200px; display: block; margin: 0 auto;"></qriously>
                        <!--<img :src="wxQRCode" v-if="radio == '1'" width="200" height="200" style="display: block; margin: 0 auto;" />
                        <img :src="alipayQRCode" v-if="radio == '2'" width="200" height="200" style="display: block; margin: 0 auto;" />-->
                        <div style="line-height: 1.6; font-size: 0.7rem; margin-top: 6px;">
                            请用{{radio == '1' ? '微信' : radio == '2' ? '支付宝' : ''}}App “扫一扫” 扫上面二维码完成支付。您也可以截屏保存至手机相册后，用{{radio == '1' ? '微信' : radio == '2' ? '支付宝' : ''}}App “扫一扫” 识别截屏图片
                        </div>
                    </van-cell>
                </van-cell-group>
                <div style="height: 46px;"></div>
                <div class="buttons">
                    <span class="cancel" @click="isShowCode = false">取消</span>
                    <span class="finished" @click="payCodeComplate()">支付完成</span>
                    <div class="clearb"></div>
                </div>
            </van-popup>

            <van-popup class="paybankpopup" v-model="isPaybank" position="right">
                <van-nav-bar title="银行转账"
                    left-text=""
                    left-arrow
                    @click-left="isPaybank = false"
                />
                <van-cell-group class="detailmain">
                    <van-cell class="paybank">
                        <template slot="title">
                            <span>银行:</span>
                            <span>{{bankInfo.bank}}</span>
                        </template>
                        <!--<span>复制</span>-->
                    </van-cell>
                    <van-cell class="paybank">
                        <template slot="title">
                            <span>账户:</span>
                            <span>{{bankInfo.name}}</span>
                        </template>
                    </van-cell>
                    <van-cell class="paybank">
                        <template slot="title">
                            <span>BSB:</span>
                            <span class="fwb">{{bankInfo.bsb}}</span>
                        </template>
                    </van-cell>
                    <van-cell class="paybank">
                        <template slot="title">
                            <span>帐号:</span>
                            <span class="fwb">{{bankInfo.cardNo}}</span>
                        </template>
                    </van-cell>
                    <van-cell class="paybank">
                        <template slot="title">
                            <span>金额:</span>
                            <span class="fwb">{{ getPriceType(orderDetail.priceType).symbol }}{{bankInfo.money}} {{ getPriceType(orderDetail.priceType).unit }}</span>
                        </template>
                    </van-cell>
                    <van-cell class="paybank">
                        <template slot="title">
                            <span>订单号:</span>
                            <span class="fwb">{{bankInfo.remark}}</span>
                        </template>
                    </van-cell>
                    <van-uploader class="uploads" 
                        accept="image/*"
                        :before-read="beforeAvatarUpload"
                        :after-read="paymentResultImage"
                    >
                        <span>
                            <i v-if="!bankInfo.image">点击上传转账截屏</i>
                            <img v-else :src="bankInfo.image" />
                        </span>
                    </van-uploader>
                </van-cell-group>
                <div style="height: 46px;"></div>
                <div class="buttons">
                    <span class="cancel" @click="isPaybank = false">取消</span>
                    <span class="finished" @click="payComplate()">转账完成</span>
                    <div class="clearb"></div>
                </div>
            </van-popup>
        </div>
    </div>
</template>

<script>
    import lrz from 'lrz'
    import Vue from 'vue'
    import VueQriously from 'vue-qriously'
    Vue.use(VueQriously)
    import { Cell, CellGroup, SubmitBar, RadioGroup, Radio } from 'vant'

    export default {
        components: {
            [Cell.name]: Cell,
            [CellGroup.name]: CellGroup,
            [SubmitBar.name]: SubmitBar,
            [RadioGroup.name]: RadioGroup,
            [Radio.name]: Radio
        },
        data () {
            return {
                payOrderId: 0,
                radio: "1",
                orderDetail: {},
                isPaybank: false,
                isShowCode: false, // 显示微信，支付宝二维码界面
                wxQRCode: "",
                alipayQRCode: "",
                bankInfo: {
                    "bank": "",
                    "name": "",
                    "bsb": "",
                    "cardNo": "",
                    "remark": "",
                    "money": "",
                    "image": ""
                },
                browser: {
                    wechat: false,
                    alipay: false,
                    other: false
                },
                appConfig: {},
                amountRate: 1,   // 手续费率
                serviceAmount: 0,    // 手续费
                totalAmounts: 0, // 加了手续费的总额
                paymentAmountRMB: 0, // 应付人民币
            }
        },
        mounted() {
            this.payOrderId = this.$route.params.id;
            this.getAppSetting();
            this.getBrowser();
            this.getOrderDetail();
        },
        methods: {
            getAppSetting() {
                this.axios.get(window.consts.apis.getAppSetting).then(res=>{
                    if(res.success && res.result){
                        this.appConfig = res.result
                        this.amountRate = res.result.serviceAmountRate * 100
                    }
                })
            },
            getBrowser() {
                if (/MicroMessenger/.test(window.navigator.userAgent)) { 
                    this.browser.wechat = true;
                    this.radio = '1';
                } else if (/AlipayClient/.test(window.navigator.userAgent)) { 
                    this.browser.alipay = true;
                    this.radio = '2';
                } else {
                    this.browser.other = true;
                    this.radio = '1';
                }
            },
            getBankInfo() {
                this.$axios.get(window.consts.apis.bankInfo).then(res => {
                    if (res.success) {
                        for (var i in res.result) {
                            this.bankInfo[i] = res.result[i];
                        }
                        this.bankInfo.money = this.orderDetail.paymentAmount;
                        this.bankInfo.remark = this.payOrderId;
                        this.isPaybank = true;
                    } else {
                        this.isPaybank = false;
                        this.$dialog.alert({ message: res.error.message });
                        return false;
                    }
                });
            },
            getOrderDetail() {
                this.showLoading();
                this.$axios.get(window.consts.apis.orderDetail, {params:{ id: this.payOrderId }}).then(res => {
                    this.hideLoading();
                    if (res.success) {
                        let item = res.result;
                        this.orderDetail = res.result;
                        this.paymentAmountRMB = this.toFixed(item.paymentAmount * (this.appConfig && this.appConfig.exchangeRate)) // 人民币
                        let freight = item.freight && item.freight || 0;
                        if (this.orderDetail.items && freight > 0) {
                            this.orderDetail.items.push({
                                "commodityId": 0,
                                "commodityName": "快递运费",
                                "commodityImageUrl": null,
                                "commodityOriginalPrice": freight,
                                "commodityPrice": freight,
                                "quantity": 1
                            });
                        }
                        let takePhotoAmount = item.needTakePhoto && item.takePhotoAmount || 0;
                        if (this.orderDetail.items && takePhotoAmount) {
                            this.orderDetail.items.push({
                                "commodityId": 0,
                                "commodityName": "标记拍照服务费",
                                "commodityImageUrl": null,
                                "commodityOriginalPrice": takePhotoAmount,
                                "commodityPrice": takePhotoAmount,
                                "quantity": 1
                            });
                        }
                        let serviceAmount = item.serviceAmount && item.serviceAmount || 0;
                        if (this.orderDetail.items && serviceAmount > 0 && item.payStatus === 2) {
                            this.orderDetail.items.push({
                                "commodityId": 0,
                                "commodityName": "手续费",
                                "commodityImageUrl": null,
                                "commodityOriginalPrice": serviceAmount,
                                "commodityPrice": serviceAmount,
                                "quantity": 1
                            });
                        }
                    } else {
                        this.$dialog.alert({ message: res.error.message });
                        this.$router.push({ path: '/m' })
                        return false;
                    }
                }).catch(e => {
                    this.hideLoading();
                    this.$toast.fail("出错啦，请稍候再试!");
                    return false;
                });
            },
            onSubmitPay() {
                // 人民币支付
                if (this.orderDetail.priceType) {
                    let url = window.consts.apis.payCashier + '?orderId=' + this.orderDetail.id
                    this.totalAmounts = this.toFixed(this.orderDetail.paymentAmount)
                    // 支付宝，微信浏览器直接跳转
                    if ((this.radio == '2' && this.browser.alipay) || (this.radio == '1' && this.browser.wechat)) {
                        this.isShowCode = false
                        location.href = window.baseUrl + url
                    }
                    else { // else if (!this.browser.wechat) 
                        this.isShowCode = true;
                        this.showLoading();
                        let url = window.consts.apis.payCashier + '?orderId=' + this.orderDetail.id
                        this.$axios.get(url).then(() => {
                            this.hideLoading();
                            url = window.baseUrl + url
                            this.wxQRCode = url
                            this.alipayQRCode = url
                        })
                    }
                }
                // 澳币支付
                //微信支付
                else if (this.radio == '1') {
                    //微信浏览器
                    // 准确计算手续费
                    let curRate = this.operationAddOrSub('+', 1, this.appConfig.serviceAmountRate)
                    let multiAmount = this.operationMulti(this.orderDetail.paymentAmount, curRate)
                    this.serviceAmount = this.toFixed(this.operationMulti(this.orderDetail.paymentAmount, this.appConfig.serviceAmountRate))
                    this.totalAmounts = this.toFixed(multiAmount)
                    if (this.browser.wechat) {
                        this.toJsApiPay(1);
                    } else {
                        this.isShowCode = true;
                        if (!this.wxQRCode) {
                            this.showLoading();
                            this.$axios.post(window.consts.apis.pcPayQrCode + '?' + this.jsonToUrlParams({
                                orderId: this.orderDetail.id,
                                paymentType: 1
                            })).then(r => {
                                this.hideLoading();
                                if (r.success) {
                                    this.wxQRCode = r.result
                                    /*this.$axios.get(window.consts.apis.commonPay + '?' + this.jsonToUrlParams({
                                        orderId: this.orderDetail.id,
                                        paymentType: 1
                                    })).then(rw => {
                                        console.log(rw)
                                    })*/
                                } else {
                                    if (r.error.message.indexOf('exists') > 0) {
                                        this.$dialog.alert({ message: "该订单已生成过支付码，不能更换支付方式!" })
                                    } else {
                                        this.$dialog.alert({ message: r.error.message})
                                    }
                                    this.isShowCode = false;
                                }
                            })
                        }
                    }
                } else if (this.radio == '2') {
                    // 准确计算手续费
                    let curRate = this.operationAddOrSub('+', 1, this.appConfig.serviceAmountRate)
                    let multiAmount = this.operationMulti(this.orderDetail.paymentAmount, curRate)
                    this.serviceAmount = this.toFixed(this.operationMulti(this.orderDetail.paymentAmount, this.appConfig.serviceAmountRate))
                    this.totalAmounts = this.toFixed(multiAmount)
                    /* if (this.browser.other) {
                        //非支付宝浏览器
                        this.toH5Pay(0);
                    } */
                    if (this.browser.alipay) {
                        this.toJsApiPay(0);
                    } else {
                        this.isShowCode = true;
                        if (!this.alipayQRCode) {
                            this.showLoading();
                            this.$axios.post(window.consts.apis.pcPayQrCode + '?' + this.jsonToUrlParams({
                                orderId: this.orderDetail.id,
                                paymentType: 0
                            })).then(r => {
                                this.hideLoading();
                                if (r.success) {
                                    this.alipayQRCode = r.result
                                } else {
                                    if (r.error.message.indexOf('exists') > 0) {
                                        this.$dialog.alert({ message: "该订单已生成过支付码，不能更换支付方式!" })
                                    } else {
                                        this.$dialog.alert({ message: r.error.message})
                                    }
                                    this.isShowCode = false;
                                }
                            }).catch(e => {
                                this.hideLoading();
                                this.$toast.fail("出错啦，请稍候再试!");
                                return false;
                            })
                        }
                    }
                } else {
                    this.serviceAmount = 0
                    this.totalAmounts = this.orderDetail.paymentAmount
                    this.getBankInfo();
                }
            },
            toJsApiPay(payType) {
                this.showLoading();
                this.$axios.post(window.consts.apis.jsApiPay + "?" + this.jsonToUrlParams({
                    orderId: this.payOrderId,
                    paymentType: payType
                })).then(res => {
                    this.hideLoading();
                    if (res.success) {
                        let message = "";
                        if (this.serviceAmount > 0) {
                            message = "您总共需支付$" + this.totalAmounts + "，<br />商品价格：$" + this.orderDetail.paymentAmount + "，手续费：$" + this.serviceAmount + "，请确认?";
                        } else {
                            message = "您需支付$" + this.totalAmounts + "，请确认?";
                        }
                        this.$dialog.confirm({
                            message: message
                        }).then(r => {
                            location.href = res.result;
                        })
                    } else {
                        this.$toast.fail(res.error.message)
                    }
                }).catch(e => {
                    this.hideLoading();
                    this.$toast.fail("出错啦，请稍候再试!");
                    return false;
                });
            },
            toH5Pay(payType) {
                this.showLoading();
                this.$axios.post(window.consts.apis.h5Pay + "?" + this.jsonToUrlParams({
                    orderId: this.payOrderId,
                    paymentType: payType
                })).then(res => {
                    this.hideLoading();
                    if (res.success) {
                        let message = "";
                        if (this.serviceAmount > 0) {
                            message = "您需支付$" + this.totalAmounts + "，<br />商品价格：$" + this.orderDetail.paymentAmount + "，手续费：$" + this.serviceAmount + "，请确认?";
                        } else {
                            message = "您需支付$" + this.totalAmounts + "，请确认?";
                        }
                        this.$dialog.confirm({
                            message: message
                        }).then(r => {
                            location.href = res.result;
                        })
                    } else {
                        this.$toast.fail(res.error.message)
                    }
                }).catch(e => {
                    this.hideLoading();
                    this.$toast.fail("出错啦，请稍候再试!");
                    return false;
                });
            },
            payComplate() {
                if (!this.bankInfo.image) {
                    this.$dialog.alert({ message: "请先上传支付截屏!" });
                    return false;
                } else {
                    let transPay = {
                        transferImage: this.bankInfo.image,
                        id: this.payOrderId
                    };
                    this.$axios.post(window.consts.apis.transferPay, transPay).then(res => {
                        if (res.success) {
                            this.$dialog.alert({ 
                                message: "已成功上传转账截图!核对转账是人工处理过程，请耐心等待。核对之后，您的订单支付状态才会变为已支付。" 
                            }).then(r => {
                                this.$router.push({ path: '/m/pendingpayment/0', query: { orderId: this.orderDetail.id }});
                            });
                        }
                    })
                }
            },
            //扫码支付完成
            payCodeComplate() {
                this.$router.push({ path: '/m/pendingpayment/0', query: { orderId: this.orderDetail.id }});
            },
            //图片上传之前
            beforeAvatarUpload (file) {
                /*const isLt2M = file.size / 1024 / 1024 < 5
                if (!isLt2M) {
                    this.$toast.fail('身份证图片大小不能超过5MB!')
                    return false
                }*/
                return true
            },
            paymentResultImage(res, file) {
                this.showLoading()
                lrz(res.file, {
                    width: 1000,
                    quality: 0.7
                }).then(rst => {
                    let fd = new FormData()
                    fd.append("File", res.file)
                    this.$axios.post(window.consts.apis.uploadFile, rst.formData, {
                        headers: {
                            "Content-Type": "multipart/form-data",
                            "Authorization": this.uploadHeaders.Authorization
                        }
                    }).then(r => {
                        this.hideLoading()
                        if (r.success) {
                            this.bankInfo.image = r.result.fileUrl
                        } else {
                            this.$toast.fail(r.error.message)
                        }
                    }, error => {
                        this.hideLoading()
                        this.$toast.fail("转账截图上传失败，请稍候再试!")
                    })
                }).catch(e => {
                    this.hideLoading()
                    this.$toast.fail("上传出错啦，请重试!")
                })
            },
            showLoading() {
                this.$toast.loading({
                    duration: 0,
                    forbidClick: true,
                    loadingType: 'spinner',
                    message: '加载中...'
                });
            },
            hideLoading() {
                this.$toast.clear()
            }
        }
    }
</script>

<style lang="scss" scoped>
    .van-submit-bar {
        bottom: 60px;
        background:#01579b;
        .van-submit-bar__text {
            span {
                color:#fff;
                font-size: 16px;
            }
        }
    }
    .pend_main,.pend_detail {
        .van-cell-group {
            margin-top: 15px;
            border-top: 1px solid #ddd;
            border-bottom: 1px solid #ccc;
        }
        .small {
            padding: 5px 15px;
            .van-field {
                padding: 0 15px;
            }
        }
        .time {
            .van-cell__value {
                flex: 2;
            }
        }
        .orderid {
            font-size: 16px;
            font-weight: 700;
            color: #262626;
        }
        .money {
            font-size: 14px;
            font-weight: bold;
            color: #f21c0d;
        }
        .paystate {
            padding: 3px 8px;
            color: #fff;
        }
        .payunfinished {
            background: #ed5565;
        }
        .payfinished {
            background: #55edc3;
        }
        .products {
            margin: 0;
            padding: 10px 15px;
            background:#f5f5f5;
            dl {
                margin: 6px 0;
                padding: 0;
            }
            dt {
                margin: 0;
                padding: 0;
                float: left;
                width: 88%;
            }
            dd {
                margin: 0;
                padding: 0;
                line-height: 1.5;
                float: right;
                color: #999;
            }
        }
        .paygroup {
            .van-cell__title {
                flex: 4;
                height: 26px;
                line-height: 26px;
                img {
                    width:26px;
                }
                span {
                    display: inline-block;
                    margin-left: 10px;
                    font-size: 15px;
                    vertical-align: top;
                }
            }
        }
        .paybankpopup {
            width:100%;
            height:100%;
            .detailmain {
                margin-top:46px;
                height: calc(100% - 95px);
                overflow-y: auto;
            }
            .van-cell__title {
                flex: 4;
                font-size: 16px;
            }
            .van-cell__value {
                overflow: visible;
            }
            .paybank {
                span:nth-child(1) {
                    display:inline-block;
                    width: 80px;
                }
            }
            .fwb {
                font-weight: bold;
            }
            .buttons {
                position: fixed;
                width:100%;
                height: 44px;
                line-height: 44px;
                text-align: center;
                color: #fff;
                font-size: 15px;
                font-weight: bold;
                bottom: 0;
                left: 0;
                .cancel {
                    float: left;
                    width: 33%;
                    height:100%;
                    background:#ffb03f;
                }
                .finished {
                    float: right;
                    width: 67%;
                    height:100%;
                    background:#f15353;
                }
            }
        }
        .paymentmain {
            .payorder {
                .van-cell__value {
                    flex: 4;
                }
            }
        }
        .uploads {
            margin: 20px 0 5px 4%;;
            width:92%;
            height:auto;
            min-height:100px;
            border:1px dashed #dddddd;
        }
        .uploads span {
            display: block;
            width:100%;
            height: 100%;
            text-align: center;
            i {
                display: inline-block;
                width:100%;
                height:100px;
                line-height: 100px;
                font-style: normal;
                color: #999;
            }
            img {
                display: inline-block;
                width: 100%;
                height: 100%;
            }
        }
    }
    .pend_opera {
        .title {
            padding: 10px 0;
            font-size: 14px;
            text-align: center; 
            color: #999;
        }
        .van-cell {
            padding: 5px 15px;
        }
        .van-button {
            width: 100%;
        }
    }
    .pend_detail {
        .van-popup {
            width: 100%;
            height: 100%;
        }
        .van-nav-bar {
            position: absolute;
        }
        .detailmain {
            margin-top: 46px;
            height: calc(100% - 46px);
            overflow-y: auto;
        }
        .grouptitle {
            background:#eee;
            font-size: 16px;
            padding:10px 15px;
            color: #1ab394;
        }
        .remark {
            padding:10px 15px;
            min-height: 50px;
            line-height: 1.6;
        }
    }
    .order_result {
        text-indent: 12px;
        .amount {
            color: #fff;
            font-size: 16px;
        }
        .rmb {
            color: #eee;
            font-size: 13px;
            margin-left: 10px;
        }
    }
</style>
